
import AppBar from '@material-ui/core/AppBar';
import CloseIcon from '@material-ui/icons/Close';

import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import React from 'react';
import ReactDiffViewer from 'react-diff-viewer';
import SplitPane from 'react-split-pane';
import Toolbar from '@material-ui/core/Toolbar';

import LZString from 'lz-string';

import memoizeOne from 'memoize-one';

import loadoutIcons from '../ReactProtos/Data/LoadoutIcons';
import cardIcons from '../ReactProtos/Data/CardIcons';
import guildChestIcons from '../ReactProtos/Data/GuildChestIcons';
import cardInfoStatsIcons from '../ReactProtos/Data/CardInfoStatsIcons'
import ChestShowcasePrefabs from '../ReactProtos/Data/ChestShowcasePrefabs'
import cardPortraits from '../ReactProtos/Data/CardPortraits';
import skillIcons from '../ReactProtos/Data/SkillIcons';
import chestIcons from '../ReactProtos/Data/ChestIcons';
import inAppPurchaseIcons from '../ReactProtos/Data/InAppPurchaseIcons';
import inventoryItemIcons from '../ReactProtos/Data/InventoryItemIcons';
import iapBundleBannerNamesWithNull from '../ReactProtos/Data/IapBundleBannerNamesWithNull';
import chestPrefabs from "../ReactProtos/Data/ChestPrefabs";
import fontSprites from "../ReactProtos/Data/FontSprites";
import mapEventOverviewPanels from "../ReactProtos/Data/MapEventOverviewPanels";
import showcaseCardPortraits from "../ReactProtos/Data/ShowcaseCardPortraits";
import supportedInGameIcons from "../ReactProtos/Data/InGameIconNames";
import dealPageFeaturePackTemplatePrefab from "../ReactProtos/Data/DealPageFeaturePackTemplatePrefab";
import bundlePopUpBackgrounds from "../ReactProtos/Data/BundlePopUpBackgrounds";

import { Button, Modal } from 'react-bootstrap';
import { FieldDescriptor } from '../ReactProtos/Helper/Descriptor';
import { LocalizedInput } from './LocalizedInput';
import { Menu, Item } from 'react-contexify';
import { ProtoEditor } from '../ReactProtos/ProtoEditor';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DehazeOutlinedIcon from '@material-ui/icons/DehazeOutlined';

import { default as MaterialButton } from '@material-ui/core/Button';

import 'react-table/react-table.css';

import './custom.scss';
import './EditorBase.scss';
import { InAppPurchaseData } from '../ReactProtos/Proto/dcei_wildsky_in_app_purchase_proto';

/* eslint react/prop-types: 0 */

function applyAction(data, action) {
    if (action.type == 'BATCH') {
        for (let item of action.actions) {
            data = applyAction(data, item);
        }
        return data;
    }
    return data.apply(action.type, action.path, action.value);
}

const FormContextMenu = (props) => {
    const { onClick } = props;
    return (
        <Menu id={props.id}
            style={{ zIndex: 100000 }}>
            <Item onClick={(e, props) => onClick('Clear', e, props)}>Clear</Item>
            <Item onClick={(e, props) => onClick('Copy', e, props)}>Copy</Item>
            <Item onClick={(e, props) => onClick('Paste', e, props)}>Paste</Item>
        </Menu>
    );
};

class PureReactDiffViewer extends React.PureComponent {
    render() {
        return <ReactDiffViewer
            oldValue={this.props.oldValue}
            newValue={this.props.newValue}
            splitView={true}
        />;
    }
}

export class WildSkyContext {
    /**
     * @param {object} owner
     * @param {string} name
     * @param {string} file
     */
    constructor(owner, name, file) {
        this.owner = owner;
        this.name = name;
        this.file = file;
        this.contextMenuId = name + '-menu';
    }

    getHardcodedOptions(key) {
        switch (key) {
            case "GuildChestIcons":
                return guildChestIcons;
            case "LoadoutIcons":
                return loadoutIcons;
            case "CardIcons":
                return cardIcons;
            case "CardInfoStatsIcons":
                return cardInfoStatsIcons;
            case "ChestShowcasePrefabs":
                return ChestShowcasePrefabs;
            case "CardPortraits":
                return cardPortraits;
            case "SkillIcons":
                return skillIcons;
            case "ChestIcons":
                return chestIcons;
            case "InAppPurchaseIcons":
                return inAppPurchaseIcons;
            case "InventoryItemIcons":
                return inventoryItemIcons;
            case "IapBundleBannerNamesWithNull":
                return iapBundleBannerNamesWithNull;
            case "DailyQuestOpenDaysStringList":
                return ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
            case "SupportedLanguageCodes":
                return ["en", "zh-CN", "es", "pt", "ko", "ja", "zh-TW", "fr", "de", "ru"].sort();
            case "IapBundleAssetList":
                return ["btn_bundle_eventbundle", "btn_bundle_starterpack", "btn_bundle_privilegecard", "btn_bundle_goldpass"].sort();
            case "ChestPrefabs":
                return chestPrefabs;
            case "FontSprites":
                return fontSprites;
            case "MapEventOverviewPanels":
                return mapEventOverviewPanels;
            case "ShowcaseCardPortraits":
                return showcaseCardPortraits;
            case "SupportedInGameIcons":
                return supportedInGameIcons;
            case "BundlePopUpBackgrounds":
                return bundlePopUpBackgrounds;
            case "DealPageFeaturePackTemplatePrefab":
                return dealPageFeaturePackTemplatePrefab;
            case "MapQuestIcons":
                return inventoryItemIcons.slice().concat(["task_campaign", "task_elementaltrial", "task_event",
                    "task_mine", "task_event_water", "task_event_light", "task_event_dark", "task_event_nature", "task_event_physical"])
            case "DealPageBundleBackgroundAssets":
                return ["frame_deal_chosengirl", "frame_deal_frosttower", "frame_deal_smith", "frame_deal_tesla", "frame_deal_towers_physic", "frame_deal_windknight"].sort();
            default:
                return null;
        }
    }

    options = {
        CardNames: {
            file: "Card/CardDefinitions.json",
            getValues: data => {
                return data.cardDefinitions.map(card => card.name);
            },
        },
        SkinNames: {
            file: "Card/CardSkinDefinitions.json",
            getValues: data => {
                return data.cardSkinDefinitions.map(cardSkin => cardSkin.cardSkin).reduce((acc, it) => [...acc, ...it]).map(skin => skin.name);
            },
        },
        CardTags: {
            file: "Card/CardDefinitions.json",
            getValues: data => {
                return data.cardTags.map(cardTag => cardTag.tagName);
            },
        },
        AbilityNames: {
            repo: 'levels',
            file: 'GameData/Ability.json',
            getValues: data => {
                return Object.keys(data.abilities);
            },
        },
        WeaponNames: {
            repo: 'levels',
            file: 'GameData/Weapon.json',
            getValues: data => {
                return Object.keys(data.weapons);
            },
        },
        BehaviorNames: {
            repo: 'levels',
            file: 'GameData/Behavior.json',
            getValues: data => {
                return Object.keys(data.behaviors);
            },
        },
        UnitNames: {
            repo: 'levels',
            file: 'GameData/Unit.json',
            getValues: data => {
                return Object.keys(data.units);
            },
        },
        SupportedDataUpgrades: {
            repo: 'levels',
            file: 'GameData/Upgrade.json',
            getValues: data => {
                return Object.keys(data.dataUpgrades);
            },
        },
        RewardItemKeyList: {
            file: 'InventoryData.json',
            getValues: data => {
                return data.Items.map(i => i.key);
            },
        },
        MapKeyList: {
            file: 'Map.json',
            getValues: data => {
                return data.maps.map(i => i.key);
            },
        },
        MailKeyList: {
            file: 'MailData.json',
            getValues: data => {
                return data.mailGroups.map(i => i.key);
            },
        },
        MarketTabKeyList: {
            repo: 'serverdata',
            file: 'MarketData.json',
            getValues: data => {
                return data.tabs.map(i => i.key);
            },
        },
        RewardPatternKeyList: {
            file: 'Dungeons.json',
            getValues: data => {
                return data.rewardPatterns.rewardPatterns.map(i => i.patternName);
            },
        },
        IapBundleList: {
            repo: 'serverdata',
            file: 'InAppPurchaseData.json',
            getValues: data => {
                return data.products.map(i => i.id).concat(
                    data.limitedBundles.map(i => i.productId)
                ).concat(
                    data.bundleDefinitions.map(i => i.productId)
                ).concat(
                    data.campaignSaleBundles.map(i => i.productId)
                ).concat(
                    data.subscriptions.map(i => i.productId)
                );
            },
        },

        ShopProductIdList: {
            repo: 'serverdata',
            file: 'InAppPurchaseData.json',
            getValues: data => {
                return data.products.map(i => i.id).concat(
                    data.limitedBundles.map(i => i.productId)
                ).concat(
                    data.subscriptions.map(i => i.productId)
                );
            },
        },

        DailyTrialBundleIdList: {
            repo: 'serverdata',
            file: 'InAppPurchaseData.json',
            getValues: data => {
                return data.dailyTrialBundles.map(i => i.productId)
            },
        },
        DailyTrialChestKeyList: {
            repo: 'serverdata',
            file: 'DailyTrialData.json',
            getValues: data => {
                return data.chests.map(i => i.key)
            },
        },
        DailyTrialRewardKeyList: {
            repo: 'serverdata',
            file: 'DailyTrialData.json',
            getValues: data => {
                return data.rewards.map(i => i.key)
            },
        },
        QuestAndAchievementNameList: {
            file: 'QuestAndAchievementData.json',
            getValues: data => {
                return data.questData.dailyQuestList.map(i => i.key).concat(
                    data.achievementData.achievementList.map(i => i.key)
                );
            },
        },
        ChestGroupKeyList: {
            repo: 'serverdata',
            file: 'GachaData.json',
            getValues: data => {
                var result = data.gachaLevelGroups.map(i => i.key)
                if (data.promotionalGachaGroups != null) {
                    result.concat(data.promotionalGachaGroups.map(i => i.key));
                }
                return result;
            },
        },
        MapEventPrefixList: {
            repo: 'serverdata',
            file: 'MapEventData.json',
            getValues: data => {
                return data.levelPrefixes.map(i => i.key);
            },
        },
        MapEventKeys: {
            repo: 'serverdata',
            file: 'MapEventData.json',
            getValues: data => {
                return data.mapEvents.map(i => i.key);
            },
        },
        MapEventCoopRewardPatternList: {
            repo: 'serverdata',
            file: 'MapEventData.json',
            getValues: data => {
                return data.mapEvents[this.owner.state.selected].liveEventConfig.coopRewardPatterns.map(i => i.key);
            },
        },
        DealBundleIds: {
            repo: 'serverdata',
            file: 'InAppPurchaseData.json',
            getValues: data => {
                return data.bundleDefinitions.map(i => i.productId);
            },
        },
        MineRewardPatternNames: {
            file: 'Mines.json',
            getValues: data => {
                return data.rewardPatterns.map(i => i.patternName);
            },
        },
        RewardPatternNames: {
            repo: 'serverdata',
            file: 'RewardPattern.json',
            getValues: data => {
                return data.rewardPatterns.map(i => i.patternName);
            },
        },
        HelpNavigationItems: {
            file: 'HelpNavigationData.json',
            getValues: data => {
                return data.navigationItemDefinitions.map(i => i.key)
            },
        },
        DailyTrailRewardKeyList: {
            repo: 'serverdata',
            file: 'DailyTrailData.json',
            getValues: data => {
                return data.rewards.map(i => i.key);
            },
        },
        DailyTrailChestKeyList: {
            repo: 'serverdata',
            file: 'DailyTrailData.json',
            getValues: data => {
                return data.chests.map(i => i.key);
            },
        }
    }

    async getValueDropdownOptionsWithLabel(key, message, field, index) {
        const values = await Promise.resolve(this.getValueDropdownOptions(key));
        const results = values.map(v => ({ value: v, label: v }));
        console.log(values, results);
        return results;
    }

    getValueDropdownOptions(key, message, field, index) {
        const hardcoded = this.getHardcodedOptions(key);
        if (hardcoded) {
            return hardcoded;
        }
        const info = this.options[key];
        if (info) {
            if (info.file === this.file) {
                return info.getValues(this.owner.state.data);
            }
            if (info.working) {
                return info.working;
            }
            info.working = fetch(`/api/gitlab/file/get?path=${encodeURIComponent(info.file)}&branch=master&repo=${info.repo}`)
                .then(res => res.json())
                .then(result => {
                    if (result.error || !result.content) {
                        console.error(result);
                        return [];
                    }
                    return info.getValues(JSON.parse(atob(result.content)));
                });
            return info.working;
        }
        console.error(`Value dropdown is not implemented for: ${key}`);
        return [];
    }
    hasValueDropdownOptions(key) {
        const hardcoded = this.getHardcodedOptions(key);
        if (hardcoded) {
            return true;
        }
        if (this.options[key]) {
            return true;
        }
        console.error(`Value dropdown is not implemented for: ${key}`);
        return false;
    }
}

function installLocalizedInput(proto) {
    if (proto.localized) {
        return;
    }
    proto.localized = true;

    for (let field of proto.descriptor.fields) {
        if (field.options.hideInInspector) {
            continue;
        }
        if (field.isMap) {
            if (field.valueProtoType === FieldDescriptor.TYPE_MESSAGE) {
                installLocalizedInput(field.valueType);
            }
        } else if (field.protoType === FieldDescriptor.TYPE_MESSAGE) {
            installLocalizedInput(field.type);
        } else if (field.protoType === FieldDescriptor.TYPE_STRING) {
            if (field.options.localization) {
                field.customEditor = LocalizedInput;
            }
        }
    }
}

class DragDropList extends React.PureComponent {
    onDragEnd = drag => {
        console.log(drag);
        if (!drag.destination) {
            return;
        }
        if (drag.source.index === drag.destination.index) {
            return;
        }
        const from = drag.source.index;
        const to = drag.destination.index;
        const fromItem = this.props.items[from];
        const toItem = this.props.items[to];
        if (fromItem.dispatchPath.length !== toItem.dispatchPath.length) {
            return;
        }
        for (let i = 0; i < fromItem.dispatchPath.length - 1; i++) {
            if (fromItem.dispatchPath[i] !== toItem.dispatchPath[i]) {
                return;
            }
        }
        console.log(fromItem, toItem);
        const parentPath = fromItem.dispatchPath.slice(0, fromItem.dispatchPath.length - 1);
        const fromIndex = fromItem.dispatchPath[fromItem.dispatchPath.length - 1];
        const toIndex = toItem.dispatchPath[toItem.dispatchPath.length - 1];
        let parent = this.props.data;
        for (let field of parentPath) {
            parent = parent[field];
        }
        const values = parent.map(i => i.selfValue.toJson());
        const [moved] = values.splice(fromIndex, 1);
        values.splice(toIndex, 0, moved);
        this.props.dispatch({ type: 'SET', path: parentPath, value: values });
    }

    render() {
        return (
            <DragDropContext onDragEnd={this.onDragEnd}>
                <div>
                    <h4 className={"drag-drop-title" + (this.props.selected === -1 ? " selected" : "")} onClick={() => this.props.onSelect(-1)}>{this.props.title}</h4>
                    <Droppable droppableId="dragdroplist">
                        {
                            (provided, snapshot) => (
                                <div {...provided.droppableProps} ref={provided.innerRef}>
                                    <div className={"droppable" + (snapshot.isDraggingOver ? " dragging-over" : "")}>
                                        {
                                            this.props.items.map((item, i) => (
                                                <Draggable draggableId={"d" + item.label} key={item.label} index={i}>
                                                    {
                                                        (provided, snapshot) => (
                                                            <div {...provided.draggableProps} ref={provided.innerRef}>
                                                                <div className={"draggable" + (snapshot.isDragging ? " dragging" : "") + (i === this.props.selected ? " selected" : "")}>
                                                                    <div {...provided.dragHandleProps}>
                                                                        <DehazeOutlinedIcon />
                                                                    </div>
                                                                    <div style={{ flexGrow: 1 }} onClick={() => this.props.onSelect(i)}>
                                                                        {item.label}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </Draggable>
                                            ))
                                        }
                                        {provided.placeholder}
                                    </div>
                                </div>
                            )
                        }
                    </Droppable>
                </div>
            </DragDropContext>
        );
    }
}

export class EditorBase extends React.PureComponent {
    dispatchPath = [];

    constructor(props) {
        super(props);

        installLocalizedInput(props.proto);

        this.repo = (window.gitlabProjectPrefix || 'wildsky') + '-' + (props.repo || 'data');
        this.STORAGE_KEY = this.props.name + ".Data";
        this.STORAGE_KEY_GITLAB = this.props.name + ".GitlabData";
        this.protoContext = new WildSkyContext(this, this.props.proto.name, this.props.file);
        this.protoContext.supportDragDrop = true;
        this.protoContext.alwaysCollapse = true;

        this.state = {
            loading: false,
            files: [],
            downloading: false,
            href: '',
            data: this.props.data || this.getSavedData() || this.props.proto.WithParent.default,
            selected: null,
            fetching: false,
            gitlabData: this.getSavedGitlabData(),
            gitlabRemote: 'webeditor',
            gitlabCommit: '',
            gitlabMessage: '',
            gitlabSource: 'master',
        };
    }

    getSavedData() {
        const text = window.localStorage.getItem(this.STORAGE_KEY);
        if (!text) {
            return null;
        }
        return new this.props.proto.WithParent(this.props.proto.fromJson(JSON.parse(text)), null);
    }

    getSavedGitlabData() {
        const text = window.localStorage.getItem(this.STORAGE_KEY_GITLAB);
        if (!text) {
            return null;
        }
        return JSON.parse(LZString.decompress(text));
    }

    componentDidUpdate() {
        if (!this.waitingToSaveLocalStorage) {
            this.waitingToSaveLocalStorage = true;
            setTimeout(function () {
                window.localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.state.data.selfValue.toJson()));
                if (this.state.gitlabData) {
                    window.localStorage.setItem(this.STORAGE_KEY_GITLAB, LZString.compress(JSON.stringify(this.state.gitlabData)));
                }
                this.waitingToSaveLocalStorage = false;
            }.bind(this), 10000);
        }
    }

    dispatch = action => {
        const data = this.state.data;
        const newSelfData = applyAction(data.selfValue, action);
        if (newSelfData !== data.selfValue) {
            const newData = data.update(newSelfData, data.parentValue);
            if (newData !== data) {
                this.setState({ data: newData });
            }
            this.props.onChange && this.props.onChange(newData);
        }
    }

    handleProtoContextMenuClick = (menuItem, e) => {
        console.log('handleProtoContextMenuClick', menuItem, e.props);
        switch (menuItem) {
            case 'Copy': {
                let target
                if (e.props.field.isMap) {
                    if (e.props.field.valueType == FieldDescriptor.TYPE_MESSAGE) {
                        const dict = e.props.message['self' + e.props.field.Name];
                        target = Object.keys(dict).map(i => i.selfValue.toJson())
                    } else {
                        target = e.props.message['self' + e.props.field.Name];
                    }

                } else if (e.props.field.isRepeated) {
                    const fieldValue = e.props.message['self' + e.props.field.Name]
                    if (e.props.field.protoType == FieldDescriptor.TYPE_MESSAGE) {
                        if (e.props.index != null) {
                            if (e.props.id == null) {
                                target = fieldValue[e.props.index].selfValue.toJson();
                            }
                            else {
                                var nf = fieldValue[e.props.index][e.props.id]
                                if (nf.selfValue == null) {
                                    target = nf;
                                }
                                else {
                                    target = nf.selfValue.toJson();
                                }
                            }
                        }
                        else {
                            target = fieldValue.map(i => i.selfValue.toJson());
                        }
                    } else {
                        if (e.props.index != null) {
                            target = fieldValue[e.props.index];
                        }
                        else {
                            target = fieldValue.map(i => i);
                        }
                    }
                } else if (e.props.field.protoType == FieldDescriptor.TYPE_MESSAGE) {
                    target = e.props.data.selfValue.toJson();
                } else {
                    target = e.props.value;
                }
                console.log('copied value', JSON.stringify(target));
                window.localStorage.setItem('editor-clipboard', JSON.stringify(target));
                break;
            }
            case 'Paste': {
                if (e.props.dispatchPath) {
                    this.dispatch({
                        type: 'SET', path: e.props.dispatchPath, value: JSON.parse(
                            window.localStorage.getItem('editor-clipboard')
                        )
                    });
                }
                break;
            }
            case 'Clear': {
                if (e.props.dispatchPath) {
                    this.dispatch({ type: 'DELETE', path: e.props.dispatchPath });
                }
                break;
            }
            default: {
                console.error('Unknown menu item', menuItem);
                break;
            }
        }
    }

    onChangeFile = e => {
        console.log(e.target.files);
        this.setState({ files: e.target.files });
    }

    load = () => {
        this.setState({ loading: true });
    }

    cancelLoad = () => {
        this.setState({ loading: false });
    }

    upload = () => {
        const reader = new FileReader();
        reader.onload = () => {
            try {
                const newData = this.props.proto.fromJson(JSON.parse(reader.result));
                this.setState({ loading: false, data: new this.props.proto.WithParent(newData, null) });
            } catch (error) {
                this.setState({ loading: false, error: error.message, stack: error.stack });
            }

        };
        reader.readAsText(this.state.files[0]);
    }

    startDownload = () => {
        const text = JSON.stringify(this.state.data.selfValue.toJson(), null, 4);
        const blob = new Blob([text], { type: 'application/json' });
        const href = URL.createObjectURL(blob);
        this.setState({ href, downloading: true });
    }

    cancelDownload = () => {
        this.setState({ downloading: false });
    }

    download = () => {
        var element = document.createElement('a');
        element.setAttribute('href', this.state.href);
        element.setAttribute('download', this.props.file);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);

        this.setState({ downloading: false });
    }

    getFieldValue(proto, fields) {
        let result = proto;
        for (let field of fields) {
            result = result[field];
        }
        return result;
    }

    fetchFromGitlab = () => {
        if (!this.state.gitlabSource) {
            this.setState({ error: 'You must specify a branch to load data from.' });
            return;
        }
        this.setState({ startFetching: false, fetching: true });
        fetch(`/api/gitlab/file/get?repo=${this.props.repo || 'data'}&path=${encodeURIComponent(this.props.file)}&branch=${encodeURIComponent(this.state.gitlabSource)}`)
            .then(res => res.json())
            .then(result => {
                if (this.state.fetching) {
                    console.log(result);
                    if (result.error) {
                        this.setState({ fetching: false, error: result.error });
                    } else if (!result.content) {
                        this.setState({ fetching: false, error: result });
                    } else {
                        const content = decodeURIComponent(escape(atob(result.content)));
                        const newData = this.props.proto.fromJson(JSON.parse(content));
                        this.setState({ fetching: false, data: new this.props.proto.WithParent(newData, null), gitlabData: result });
                    }
                }
            });
    }

    cancelFetchFromGitlab = () => {
        this.setState({ fetching: false });
    }

    onChangeText = name => e => {
        this.setState({ [name]: e.target.value });
    }

    pushToGitlab = () => {
        const commit = this.getBaseCommit();
        if (!commit) {
            this.setState({ startPushing: false, error: 'You must specify a base commit to push.' });
            return;
        }
        if (!this.state.gitlabRemote || this.state.gitlabRemote === 'master') {
            this.setState({ startPushing: false, error: 'You must specify a branch to push to and it cannot be master.' });
            return;
        }
        if (!this.state.gitlabMessage) {
            this.setState({ startPushing: false, error: 'You must specify a commit message.' });
            return;
        }
        this.setState({ pushing: true });
        const text = JSON.stringify(this.state.data.selfValue.toJson(), null, 4);
        fetch(`/api/gitlab/file/push`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                repo: this.props.repo,
                path: this.props.file,
                commit,
                text,
                branch: this.state.gitlabRemote,
                message: this.state.gitlabMessage,
            }),
        })
            .then(response => {
                if (response.status !== 200) {
                    return response.text().then(text => {
                        this.setState({ pushing: false, error: text });
                        return Promise.reject(text);
                    });
                }
                return response;
            })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ pushing: false, error: result.error });
                } else {
                    this.setState({
                        startPushing: false, pushing: false, message: <div>
                            Pushed new commit {this.state.gitlabMessage} to
                            branch <a href={`https://gitlab.corp.dreamcraft.com/dreamcraft/${this.repo}/commits/${this.state.gitlabRemote}`} target="_blank" rel="noopener noreferrer">
                                {this.state.gitlabRemote}
                            </a>. After reviewing the commit, you can use a merge request to merge it to the master branch.
                        </div>
                    });
                }
            });
    }

    getBaseCommit() {
        if (this.state.gitlabCommit) {
            return this.state.gitlabCommit;
        }
        return this.state.gitlabData ? this.state.gitlabData.commit_id : '';
    }

    startPushing = () => {
        const content = decodeURIComponent(escape(atob(this.state.gitlabData.content)));
        const old = JSON.stringify(this.props.proto.fromJson(JSON.parse(content)).toJson(), null, 4);
        const current = JSON.stringify(this.state.data.selfValue.toJson(), null, 4);
        if (old == current) {
            this.setState({ message: <div>Data is not changed in the editor.</div> });
            return;
        }
        this.setState({ startPushing: true, diffOldText: old, diffNewText: current });
    }

    cancelStartPushing = () => {
        if (this.state.pushing) {
            return;
        }
        this.setState({ startPushing: false });
    }

    startFetching = () => {
        this.setState({ startFetching: true });
    }

    cancelStartFetching = () => {
        this.setState({ startFetching: false });
    }

    onDragEnd = drag => {
        if (!drag.destination) {
            return;
        }
        if (drag.source.droppableId !== drag.destination.droppableId) {
            return;
        }
        if (drag.source.index === drag.destination.index) {
            return;
        }
        const path = drag.source.droppableId.split('-');
        let parent = this.state.data;
        for (let field of path) {
            parent = parent[field];
        }
        const values = typeof parent[0] === 'object' ? parent.map(i => i.selfValue.toJson()) : parent;
        const [moved] = values.splice(drag.source.index, 1);
        values.splice(drag.destination.index, 0, moved);
        this.dispatch({ type: 'SET', path, value: values });
    }

    render() {
        const menuItems = this.props.menu && this.props.menu.getItems(this.state.data);
        const selectedItem = menuItems && menuItems[this.state.selected];
        const selectedProto = selectedItem && this.getFieldValue(this.state.data, selectedItem.dispatchPath);
        if (!this.dispatchPathSelector) {
            this.dispatchPathSelector = memoizeOne((...path) => [...path]);
        }
        const selectedPath = selectedItem && this.dispatchPathSelector(...selectedItem.dispatchPath);
        return (<div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
            <Dialog open={!!this.state.error}>
                <Modal.Header>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {typeof this.state.error === 'string' ? this.state.error : JSON.stringify(this.state.error)}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={() => this.setState({ error: null })}>OK</Button>
                </Modal.Footer>
            </Dialog>
            <Dialog open={!!this.state.message}>
                <Modal.Header>
                    <Modal.Title>Message</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.state.message}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={() => this.setState({ message: null })}>OK</Button>
                </Modal.Footer>
            </Dialog>
            <Dialog open={this.state.downloading} onClose={this.cancelDownload}>
                <Modal.Header>
                    <Modal.Title>Download</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <a href={this.state.href} download={this.props.file}>{this.props.file}</a>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={this.cancelDownload}>Cancel</Button>
                    <Button variant="primary" onClick={this.download}>Download</Button>
                </Modal.Footer>
            </Dialog>
            <Dialog open={this.state.loading} onClose={this.cancelLoad}>
                <Modal.Header>
                    <Modal.Title>Load file</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <input
                        onChange={this.onChangeFile}
                        type="file"
                    />
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={this.cancelLoad}>Cancel</Button>
                    <Button variant="primary" onClick={this.upload} disabled={this.state.files.length == 0}>Load</Button>
                </Modal.Footer>
            </Dialog>
            <Dialog open={!!this.state.startFetching} onClose={this.cancelStartFetching}>
                <Modal.Header>
                    <Modal.Title>Load from Gitlab</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    Load {this.props.file} from gitlab? This will override your current data in the browser.
                    <div>
                        Branch to load data from: <input type="text" value={this.state.gitlabSource} onChange={this.onChangeText('gitlabSource')} />
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={this.cancelStartFetching}>No</Button>
                    <Button variant="primary" onClick={this.fetchFromGitlab}>Yes</Button>
                </Modal.Footer>
            </Dialog>
            <Dialog open={this.state.fetching}>
                <Modal.Header>
                    <Modal.Title>Load from Gitlab</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    Loading {this.props.file} from gitlab...
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={this.cancelFetchFromGitlab}>Cancel</Button>
                </Modal.Footer>
            </Dialog>
            <Dialog open={!!this.state.startPushing} fullScreen onClose={this.cancelStartPushing}>
                <AppBar style={{ position: 'fixed', top: 0, bottom: 'auto' }}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={this.cancelStartPushing} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        {
                            this.state.pushing &&
                            <div>Uploading...</div>
                        }
                        {
                            !this.state.pushing &&
                            <MaterialButton variant="contained" color="secondary" onClick={this.pushToGitlab}>Push</MaterialButton>
                        }
                    </Toolbar>
                </AppBar>
                <div style={{ paddingTop: '50px' }}>
                    <Modal.Header>
                        <Modal.Title>Push to Gitlab</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div>
                            Push to gitlab remote branch: <input type="text" value={this.state.gitlabRemote} onChange={this.onChangeText('gitlabRemote')} />
                        </div>
                        <div>
                            Commit message: <input type="text" value={this.state.gitlabMessage} onChange={this.onChangeText('gitlabMessage')} />
                        </div>
                        <PureReactDiffViewer
                            oldValue={this.state.diffOldText}
                            newValue={this.state.diffNewText}
                        />
                    </Modal.Body>

                    <Modal.Footer>
                    </Modal.Footer>
                </div>
            </Dialog>
            <div>
                <Button onClick={this.startFetching}>Load from Gitlab</Button>
                {
                    this.state.gitlabData &&
                    <Button onClick={this.startPushing}>Push to Gitlab</Button>
                }
                <Button onClick={this.load}>Upload</Button>
                <Button onClick={this.startDownload}>Download</Button>
            </div>
            <div>
                <h1 style={{ display: 'inline' }}>{this.props.name}</h1>
                <Button onClick={this.props.onSwitch}>switch</Button>
            </div>
            {
                this.state.gitlabData &&
                <div>
                    Loaded from commit
                    <a href={`https://gitlab.corp.dreamcraft.com/dreamcraft/${this.repo}/blob/${this.state.gitlabData.commit_id}/${this.props.file}`} target="_blank" rel="noopener noreferrer">
                        {this.state.gitlabData.commit_id}
                    </a>
                </div>
            }
            <DragDropContext onDragEnd={this.onDragEnd}>
                <div style={{ flexGrow: 1, position: 'relative' }}>
                    {
                        this.props.menu &&
                        <SplitPane split="vertical" defaultSize={200} style={{ borderTop: 'solid 1px' }}>
                            <div style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, overflow: 'auto', padding: '12px' }}>
                                <DragDropList title={this.props.menu.title} items={menuItems} selected={this.state.selected} onSelect={index => this.setState({ selected: index })} data={this.state.data} dispatch={this.dispatch} />
                            </div>
                            <div style={{ position: 'relative', height: '100%' }}>
                                <div style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, overflow: 'auto', padding: '12px' }}>
                                    <table className="proto_table web_table" style={{ marginBottom: '720px' }}>
                                        {false && <thead><tr><th>Field</th><th>Value</th></tr></thead>}
                                        <tbody>
                                            {
                                                selectedItem &&
                                                <ProtoEditor context={this.protoContext} dispatch={this.dispatch} dispatchPath={selectedPath} data={selectedProto} />
                                            }
                                            {
                                                !selectedItem && this.state.selected < 0 &&
                                                <ProtoEditor context={this.protoContext} dispatch={this.dispatch} dispatchPath={this.dispatchPath} data={this.state.data} />
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </SplitPane>
                    }
                    {
                        !this.props.menu &&
                        <div style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, overflow: 'auto', padding: '12px' }}>
                            <table className="proto_table web_table" style={{ marginBottom: '720px' }}>
                                {false && <thead><tr><th>Field</th><th>Value</th></tr></thead>}
                                <tbody>
                                    {
                                        selectedItem &&
                                        <ProtoEditor context={this.protoContext} dispatch={this.dispatch} dispatchPath={selectedItem.dispatchPath} data={selectedProto} />
                                    }
                                    {
                                        !selectedItem &&
                                        <ProtoEditor context={this.protoContext} dispatch={this.dispatch} dispatchPath={this.dispatchPath} data={this.state.data} />
                                    }
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            </DragDropContext>
            <FormContextMenu
                id={this.props.proto.name + '-menu'}
                onClick={(i, e) => this.handleProtoContextMenuClick(i, e)}
            />
        </div >);
    }
}
